import React from "react";
import "./Category.scss";
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { ImHtmlFive } from "react-icons/im";
import { BsFiletypeCss, BsFillBootstrapFill } from "react-icons/bs";
import { IoLogoJavascript, IoLogoNodejs } from "react-icons/io";
import { SiJquery, SiExpress, SiNumpy, SiPython, SiMicrosoftexcel, SiTableau, SiPowerbi, SiMongodb, SiTailwindcss, SiPandas, SiScikitlearn, SiStreamlit, SiOpencv } from "react-icons/si";
import { GrFigma, GrReactjs } from "react-icons/gr";
import { TbSql } from "react-icons/tb";
import { CgFigma } from "react-icons/cg";


const Category = () => {
  const disabledLink = {
    color: "rgba(0,0,0,0.4)",
    pointerEvents: "none",
    cursor: "not-allowed",
  };

  return (
    <div className="navbar">
      {/* FRONTEND */}
      <div className="dropdown">
        <button className="dropbtn">
          Frontend <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/html/intro" target="_blank">
            HTML <ImHtmlFive />
          </a>
          <a href="https://v-extechsolution.in/learning/css/intro" target="_blank">
            CSS <BsFiletypeCss />
          </a>
          <a href="https://v-extechsolution.in/learning/css-advance/intro" target="_blank">
            CSS Advance <SiJquery />
          </a>
          <a href="https://v-extechsolution.in/learning/javascript/intro" target="_blank">
            JavaScript <IoLogoJavascript />
          </a>
          <a href="https://v-extechsolution.in/bootstrap/intro" target="_blank" style={disabledLink}>
            Bootstrap <BsFillBootstrapFill />
          </a>
          <a href="https://v-extechsolution.in/learning/reactjs/intro" target="_blank">
            ReactJS <GrReactjs />
          </a>
        </div>
      </div>

      {/* BACKEND */}
      <div className="dropdown">
        <button className="dropbtn">
          Backend <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/mongodb/intro" target="_blank" style={disabledLink}>
            MongoDB <SiMongodb />
          </a>
          <a href="https://v-extechsolution.in/learning/express-js/intro" target="_blank">
            Express JS <SiExpress size={18} />
          </a>
          <a style={disabledLink}>
            Node JS <IoLogoNodejs size={18} />
          </a>
        </div>
      </div>

      {/* PYTHON */}
      <div className="dropdown">
        <button className="dropbtn">
          AI/Ml <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/python/intro" target="_blank">
            Core Python <SiPython />
          </a>
          <a href="https://v-extechsolution.in/learning/numpy/intro" target="_blank">
            NumPy <SiNumpy />
          </a>
          <a href="https://v-extechsolution.in/learning/pandas/intro" target="_blank">
            Pandas <SiPandas />
          </a>
          <a href="https://v-extechsolution.in/learning/scikit-learn/intro" target="_blank">
            Scikit-learn <SiScikitlearn />
          </a>

           <a href="https://v-extechsolution.in/learning/streamlit/intro" target="_blank">
            Streamlit <SiStreamlit />
          </a>

            <a href="https://v-extechsolution.in/learning/computer-vision/intro" target="_blank">
            Computer Vision <SiOpencv />
          </a>
        </div>
      </div>

      {/* DATA ANALYSIS */}
      <div className="dropdown">
        <button className="dropbtn">
          Data Analysis <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/python/intro">Python <SiPython /></a>
          <a style={disabledLink}>Advanced Excel <SiMicrosoftexcel /></a>
          <a href="https://v-extechsolution.in/learning/sql/intro" target="_blank">
            MS SQL <TbSql size={22} />
          </a>
          <a style={disabledLink}>Power BI <SiPowerbi /></a>
          <a href="https://v-extechsolution.in/learning/excel/intro" target="_blank">
            Excel <SiTableau />
          </a>
        </div>
      </div>

      {/* APP DEVELOPMENT */}
      <div className="dropdown">
        <button className="dropbtn">
          App Development <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/react-native/intro" target="_blank">
            React Native <CgFigma size={22} />
          </a>
        </div>
      </div>

      {/* TAILWIND */}
      <div className="dropdown">
        <button className="dropbtn">
          Tailwind CSS <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/tailwindcss/intro" target="_blank">
            Tailwind <SiTailwindcss size={20} />
          </a>
        </div>
      </div>

      {/* UI/UX */}
      <div className="dropdown">
        <button className="dropbtn">
          UI/UX <IoMdArrowDropdownCircle />
        </button>
        <div className="dropdown-content">
          <a href="https://v-extechsolution.in/learning/html/intro" target="_blank">
            HTML <ImHtmlFive />
          </a>
          <a href="https://v-extechsolution.in/learning/css/intro" target="_blank">
            CSS <BsFiletypeCss />
          </a>
          <a href="https://v-extechsolution.in/learning/ui-ux/intro" target="_blank">
            UI/UX <GrFigma />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Category;
